import { css } from 'styled-components';
import { BreakpointQueryName } from '../../theme';
export const base = _ref => {
  let {
    theme,
    $sideSpacing
  } = _ref;
  return css(["position:relative;", "{padding:0 ", ";}"], theme.breakpoints.up(BreakpointQueryName.LG), theme.spaceUnits.desktop[$sideSpacing]);
};
export const scroller = css(["display:block;scroll-behavior:smooth;scroll-snap-type:x mandatory;overflow-x:auto;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{height:0;}"]);
export const content = _ref2 => {
  let {
    theme,
    sideSpacing
  } = _ref2;
  return css(["display:flex;flex-wrap:nowrap;width:100%;&:after{display:block;flex-shrink:0;flex-grow:0;content:\"\";width:", ";}", "{&:after{display:none;}}"], theme.spaceUnits.mobile[sideSpacing], theme.breakpoints.up(BreakpointQueryName.LG));
};
export const item = _ref3 => {
  let {
    theme,
    $inline,
    $itemWidth,
    $sideSpacing
  } = _ref3;
  return css(["flex-basis:", ";flex-shrink:0;min-width:0;max-width:", ";scroll-snap-align:start;scroll-margin-left:", ";scroll-margin-right:", ";scroll-snap-margin-left:", ";scroll-snap-margin-right:", ";&:not(:last-of-type){margin-right:", ";}&:first-of-type{margin-left:", ";}&:last-of-type{scroll-snap-align:end;}", "{max-width:100%;flex-basis:calc((100% + ", ") * ", " - ", ");width:calc((100% + ", ") * ", " - ", ");scroll-margin-left:0;scroll-margin-right:0;scroll-snap-margin-left:0;scroll-snap-margin-right:0;&:not(:last-of-type){margin-right:", ";}&:first-of-type{margin-left:0;}}"], $itemWidth, $itemWidth, theme.spaceUnits.mobile[$sideSpacing], theme.spaceUnits.mobile[$sideSpacing], theme.spaceUnits.mobile[$sideSpacing], theme.spaceUnits.mobile[$sideSpacing], theme.spaceUnits.mobile.SMALL, theme.spaceUnits.mobile[$sideSpacing], theme.breakpoints.up(BreakpointQueryName.LG), theme.spaceUnits.desktop.SMALL, 1 / $inline, theme.spaceUnits.desktop.SMALL, theme.spaceUnits.desktop.SMALL, 1 / $inline, theme.spaceUnits.desktop.SMALL, theme.spaceUnits.desktop.SMALL);
};
//# sourceMappingURL=HList.style.js.map